const strings = {
  CANCEL: 'Avbryt',
  DONE: 'Klar',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  MAX_BOOKINGS: 'Max antal bokningar',
  SETTING_UPDATED: 'Inställningen har uppdaterats',
  MAX_BOOKINGS_INFO:
    'Ställ in hur många tvättider en användare ska kunna boka åt gången.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditMaxBookingsModal/strings.js